import { Pipe, PipeTransform } from '@angular/core';
import Utils from '../utils/utils';
import * as moment from 'moment';

@Pipe({ name: 'time' })
export class TimePipe implements PipeTransform {

  transform(time: any, format = 'h:mm A'): any {
    return time ? moment(moment().startOf('d').format('YYYY-MM-DD') + ' ' + time).format(format) : null;
  }
}
